var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphsPsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3911_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.375V0.648438C11.875 0.296875 12.1484 0 12.5 0C17.332 0 21.25 3.91797 21.25 8.75C21.25 9.10156 20.9531 9.375 20.6016 9.375H11.875ZM1.25 10.625C1.25 5.88672 4.76953 1.96484 9.33594 1.33984C9.69531 1.28906 10 1.57812 10 1.94141V11.25L16.1133 17.3633C16.375 17.625 16.3555 18.0547 16.0547 18.2656C14.5234 19.3594 12.6484 20 10.625 20C5.44922 20 1.25 15.8047 1.25 10.625ZM21.8125 11.25C22.1758 11.25 22.4609 11.5547 22.4141 11.9141C22.1133 14.0977 21.0625 16.0391 19.5273 17.4727C19.293 17.6914 18.9258 17.6758 18.6992 17.4453L12.5 11.25H21.8125Z",
    fill: "#B692F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3911_1375"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22.5V20H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsPsvg);
export default __webpack_public_path__ + "static/media/GraphsPSVG.cc86034d0bd9488ebc990ec75d82a0d0.svg";
export { ForwardRef as ReactComponent };